import { render } from "./InterviewProfessionals.vue?vue&type=template&id=f86db5c0"
const script = {}

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__